module.exports = __webpack_public_path__ + "static/media/background2.bf266ca0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Background/background2.jpg
// module id = 926
// module chunks = 40